import { Chip } from '@mui/material';
import type { MouseEventHandler } from 'react';
import classSet from 'react-classset';

import itemUtils from '@/utils/itemUtils';

import { Permission } from '../../enums';
import type { Item } from '../../models';
import type { Permissions } from '../../models/Permissions';

export interface Iprops {
  item: Item;
  permissions: Permissions;
  hideStatus?: boolean;
  onClick?: MouseEventHandler<any> | null;
}

const FuelAssetThumbnail = ({ item, permissions, hideStatus = false, onClick = null }: Iprops) => {
  return (
    <div
      className={classSet({
        'fuel-asset-thumbnail': true,
        'collection-thumbnail': item.source === 'ClipGroup' || item.source === 'NestedChannel',
        'nested-channel-clip': item.source === 'NestedChannel',
        'live-event-clip': item.source === 'LiveEvent',
        'no-clickable': permissions && !permissions.has(Permission.EditAsset),
        [`thumbnail-border-${item.clipStatusMarker}`]: hideStatus === false && item.clipStatusMarker !== 'none',
      })}
      title={item.differenceVariantCodesWithChannel ? `Missing variants: ${item.differenceVariantCodesWithChannel}` : ''}
      onClick={(event) => {
        if (onClick) onClick(event);
      }}
    >
      <div className="thumbnail-container">
        <img className="group-thumbnail" src={item.thumbnailSrc} loading="lazy" />
        <img className="thumbnail" src={item.thumbnailSrc} loading="lazy" />
        <Chip className="clip-group-icon-chip" label={itemUtils.resolveSymbolicClipTagName(item)} size="small" />
      </div>
    </div>
  );
};

export default FuelAssetThumbnail;
